// src/pages/Connections/index.jsx
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
// primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { BreadCrumb } from "primereact/breadcrumb";
// components
import Panel from "../../components/panel/panel";
import ModalFacebook from "./Facebook/ModalFacebook";
import ModalConnections from "./ModalConnections";

const Connections = () => {
  const [visibleFacebook, setVisibleFacebook] = useState(false);
  const [visibleConnections, setVisibleConnections] = useState(false);
  const [isLoadingConnections, setIsLoadingConnections] = useState(false);
  const [connections, setConnections] = useState([
    { id: 1, name: "Conexão 1", status: 1, created_at: "2025-04-01" },
    { id: 2, name: "Conexão 2", status: 0, created_at: "2025-05-02" },
    { id: 3, name: "Conexão 3", status: 1, created_at: "2025-04-03" },
  ]);

  const columns = [
    { field: "name", header: "Nome" },
    {
      field: "status",
      header: "Status",
      body: (row) => (
        <span className={`badge ${row.status === 1 ? "badge-success" : "badge-danger"}`}>
          {row.status === 1 ? "Ativo" : "Inativo"}
        </span>
      ),
    },
    {
      field: "created_at",
      header: "Criado em",
      body: (row) => new Date(row.created_at).toLocaleDateString(),
    },
  ];

  const items = [{ template: () => <Link to="/settings/connections" className="p-breadcrumb-link">Conexões meta</Link> }];
  const home = { template: () => <Link to="#" className="p-breadcrumb-link"><i className="fa fa-home" /></Link> };

  useEffect(() => {
    setIsLoadingConnections(true);
    const timer = setTimeout(() => setIsLoadingConnections(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const { access_token, state } = Object.fromEntries(new URLSearchParams(window.location.hash.slice(1)));
    if (access_token && state === "facebook_login") {
      setVisibleFacebook(true);
    }
  }, []);

  const handleEdit = (row) => console.log("Edit Connection:", row);
  const handleDelete = (row) => console.log("Delete Connection:", row);

  return (
    <>
      <div className="row justify-content-between align-items-center mb-2">
        <div className="col-md-6">
          <BreadCrumb model={items} home={home} style={{ background: "transparent", border: "none", fontSize: "16px" }} />
        </div>
        <div className="col-md-3">
          <Button
            rounded
            label="Nova Conexão"
            icon="fa-solid fa-plus"
            className="w-100"
            onClick={() => setVisibleConnections(true)}
          />
        </div>
      </div>

      {isLoadingConnections ? (
        <Skeleton className="mt-4" width="100%" height={400} />
      ) : (
        <Panel mainCss="mt-4" title="Grupos de Acesso">
          <DataTable value={connections} paginator rows={10} rowsPerPageOptions={[10,25,50]} emptyMessage="Nenhuma informação encontrada.">
            {columns.map((col) => (
              <Column key={col.field} field={col.field} header={col.header} body={col.body} />
            ))}
            <Column header="Editar" body={(row) => <Button icon="fa-solid fa-pen-to-square" onClick={() => handleEdit(row)} />} />
            <Column header="Excluir" body={(row) => <Button icon="fa-solid fa-trash-can" severity="danger" onClick={() => handleDelete(row)} />} />
          </DataTable>
        </Panel>
      )}

      <ModalConnections
        visible={visibleConnections}
        onHide={() => setVisibleConnections(false)}
        setVisibleFacebook={setVisibleFacebook}
      />

      <ModalFacebook
        visible={visibleFacebook}
        onHide={() => setVisibleFacebook(false)}
      />
    </>
  );
};

export default Connections;
